import ContextMenuDataItem from './ContextMenuDataItem';
import createAddinCommandContextMenuData from './createAddinCommandContextMenuData';
import { AddinCommand } from 'owa-addins-store';
import { getClickHandler } from './contextMenuDataUtils';

export default function createAddinCommandContextMenuDataItem(addinCommand: AddinCommand) {
    const { Id, Label } = addinCommand.control;
    const item = new ContextMenuDataItem(Id, Label);
    if (addinCommand.isMenu) {
        item.subMenuData = createAddinCommandContextMenuData(Id, Label, addinCommand.subCommands);
    } else if (addinCommand.isActionable) {
        item.getClickHandler = getClickHandler(addinCommand);
    }
    item.iconUrl = addinCommand.control.Icon.Size16Url;
    item.accessibilityText = addinCommand.control.Label;
    item.description = addinCommand.control.Supertip.Title;
    return item;
}
